import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../utilities/RegisterUtils";
import "./Login.css";

export default function SignUp() {
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [focusedField, setFocusedField] = useState(""); // Track the focused field

  const navigate = useNavigate();

  const styles = {
    inputStyle: {
      color: "whitesmoke",
      borderRadius: "0.5rem",
      width: "22rem",
      fontSize: "14px",
    },
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validate = (data) => {
    let tempErrors = {};
    let isValid = true;
    let userRegex = "^\\S.*$";

    if (data.username === "") {
      tempErrors.username = "Username is required";
      isValid = false;
    } else if (!new RegExp(userRegex).test(data.username)) {
      tempErrors.username = "Username is invalid";
      isValid = false;
    }

    if (data.email === "") {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.email)
    ) {
      tempErrors.email = "Email is invalid";
      isValid = false;
    }

    if (data.password === "") {
      tempErrors.password = "Password is required";
      isValid = false;
    } else {
      if (data.password.length < 10 || data.password.length > 20) {
        tempErrors.password = "Password must be between 10 and 20 characters.";
        isValid = false;
      }
      if (!/[a-z]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one lowercase letter.";
        isValid = false;
      }
      if (!/[A-Z]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one uppercase letter.";
        isValid = false;
      }
      if (!/[0-9]/.test(data.password)) {
        tempErrors.password = "Password must contain at least one number.";
        isValid = false;
      }
      if (!/[!*^$@#%&)(]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one special character.";
        isValid = false;
      }
      if (/\s/.test(data.password)) {
        tempErrors.password = "Password cannot contain spaces.";
        isValid = false;
      }
      if (/(\S)\1/.test(data.password)) {
        tempErrors.password =
          "Password cannot contain consecutive repeated characters.";
        isValid = false;
      }
    }

    if (data.confirmPassword !== data.password) {
      tempErrors.confirmPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const registerNewUser = async () => {
    const payload = {
      name: userData.username,
      username: userData.email,
      password: userData.password,
    };

    try {
      const data = await registerUser(payload);
      if (data?.success === true) navigate("/login");
      else return;
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = () => {
    if (isFormValid) {
      console.log("Form is valid. Proceed with registration.");
      registerNewUser();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newUserData = {
      ...userData,
      [name]: value,
    };
    setUserData(newUserData);

    // Clear the error message for the specific field being edited
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setIsFormValid(validate(newUserData));
  };

  const handleFocus = (e) => {
    setFocusedField(e.target.name);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  useEffect(() => {
    setIsFormValid(validate(userData));
  }, [userData]);

  return (
    <div>
      <img
        src="/images/carpl_background.png"
        alt="carpl-background"
        style={{ position: "absolute", width: "100%", opacity: "0.4" }}
      ></img>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ position: "relative", left: "0rem", top: "5rem" }}
      >
        <div className="login-img-data">
          <div>
            <img src="images/carpl_logo.png" alt="Logo" />
          </div>

          <div className="login-header-data">
            Global Platform for Development, Testing & Deployment of Advanced
            Radiology Analytics
          </div>
        </div>

        <div className="register-form-container">
          <div className="login-register-heading">REGISTER</div>
          <div className="input-container">
            <div className="d-flex justify-content-start align-items-center input-field-login">
              <div className="icon-input-field">
                <i className="fa fa-address-book" aria-hidden="true" />
              </div>
              <div className="input-width-22rem ">
                <TextField
                  autoFocus
                  id="username"
                  size="small"
                  value={userData.username}
                  name="username"
                  type="text"
                  placeholder="Enter Name"
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  InputProps={{ style: styles.inputStyle }}
                />
              </div>
            </div>
            {focusedField === "username" && errors.username && (
              <p className="error-span">{errors.username}</p>
            )}

            <div className="d-flex justify-content-start align-items-center input-field-login">
              <div className="icon-input-field">
                <i className="fa fa-address-book-o" aria-hidden="true" />
              </div>

              <div className="input-width-22rem ">
                <TextField
                  autoFocus
                  id="email"
                  size="small"
                  value={userData.email}
                  name="email"
                  type="email"
                  placeholder="Enter Email"
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{ width: "22rem" }}
                  InputProps={{
                    style: styles.inputStyle,
                  }}
                />
              </div>
            </div>
            {focusedField === "email" && errors.email && (
              <p className="error-span">{errors.email}</p>
            )}

            <div className="password-container d-flex justify-content-start align-items-center input-field-login">
              <div className="d-flex justify-content-start align-items-center ">
                <div className="icon-input-field">
                  <i className="fa fa-unlock-alt" aria-hidden="true" />
                </div>
                <div className="input-width-22rem">
                  <TextField
                    autoFocus
                    size="small"
                    id="password"
                    value={userData.password}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ width: "22rem" }}
                    InputProps={{
                      style: styles.inputStyle,
                    }}
                  />
                </div>
              </div>
              <div className="toggleView ">
                <i
                  className={!showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                  id="togglePassword"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleClickShowPassword}
                />
              </div>
            </div>
            {focusedField === "password" && errors.password && (
              <p className="error-span">{errors.password}</p>
            )}

            <div className="password-container d-flex justify-content-start align-items-center input-field-login">
              <div className="d-flex justify-content-start align-items-center ">
                <div className="icon-input-field">
                  <i className="fa fa-unlock-alt" aria-hidden="true" />
                </div>
                <div className="input-width-22rem">
                  <TextField
                    autoFocus
                    size="small"
                    id="confirmPassword"
                    value={userData.confirmPassword}
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ width: "22rem" }}
                    InputProps={{
                      style: styles.inputStyle,
                    }}
                  />
                </div>
              </div>
              <div className="toggleView ">
                <i
                  className={
                    !showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"
                  }
                  id="toggleConfirmPassword"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleClickShowConfirmPassword}
                />
              </div>
            </div>
            {focusedField === "confirmPassword" && errors.confirmPassword && (
              <p className="error-span">{errors.confirmPassword}</p>
            )}
          </div>

          <button
            className="register-button"
            onClick={handleSubmit}
            disabled={!isFormValid}
          >
            <span>REGISTER</span>
          </button>
          <div className="register-text-container">
            <span style={{ color: "white" }}>Already Registered &nbsp;?</span>
            <Link
              to="/Login"
              className="register-text"
              style={{
                color: "#00c9d0",
                textDecoration: "none",
                marginLeft: "0.5rem",
              }}
            >
              Click to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
